<template>
  <b-container>
    <h1>Deleted Items</h1>
    <p>View and restore soft-deleted records.</p>

    <b-tabs content-class="mt-3">
      <b-tab title="Aspect Relationships" active>
        <div v-if="aspectRelationships.length === 0">
          <p class="text-muted">No deleted aspect relationships.</p>
        </div>
        <b-table v-else striped hover :fields="aspectFields" :items="aspectRelationships">
          <template #cell(deleted_at)="data">
            {{ formatDate(data.item.deleted_at) }}
          </template>
          <template #cell(actions)="data">
            <b-button size="sm" variant="success" @click="restoreAspectRelationship(data.item.id)">
              Restore
            </b-button>
          </template>
        </b-table>
      </b-tab>

      <b-tab title="Policy Relationships">
        <div v-if="policyRelationships.length === 0">
          <p class="text-muted">No deleted policy relationships.</p>
        </div>
        <b-table v-else striped hover :fields="policyFields" :items="policyRelationships">
          <template #cell(deleted_at)="data">
            {{ formatDate(data.item.deleted_at) }}
          </template>
          <template #cell(actions)="data">
            <b-button size="sm" variant="success" @click="restorePolicyRelationship(data.item.id)">
              Restore
            </b-button>
          </template>
        </b-table>
      </b-tab>

      <b-tab title="Notes">
        <div v-if="notes.length === 0">
          <p class="text-muted">No deleted notes.</p>
        </div>
        <b-table v-else striped hover :fields="noteFields" :items="notes">
          <template #cell(message)="data">
            {{ truncate(data.item.message, 100) }}
          </template>
          <template #cell(deleted_at)="data">
            {{ formatDate(data.item.deleted_at) }}
          </template>
          <template #cell(actions)="data">
            <b-button size="sm" variant="success" @click="restoreNote(data.item.id)">
              Restore
            </b-button>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import DeletedItemsDataService from "@/services/DeletedItemsDataService";

export default {
  data() {
    return {
      aspectRelationships: [],
      policyRelationships: [],
      notes: [],
      aspectFields: [
        { key: "aspect_name", label: "Aspect" },
        { key: "related_aspect_name", label: "Related Aspect" },
        { key: "relationship", label: "Relationship" },
        { key: "deleted_at", label: "Deleted" },
        { key: "actions", label: "" },
      ],
      policyFields: [
        { key: "policy_number", label: "Policy" },
        { key: "aspect_name", label: "Aspect" },
        { key: "relationship", label: "Relationship" },
        { key: "deleted_at", label: "Deleted" },
        { key: "actions", label: "" },
      ],
      noteFields: [
        { key: "user_name", label: "Author" },
        { key: "message", label: "Message" },
        { key: "deleted_at", label: "Deleted" },
        { key: "actions", label: "" },
      ],
    };
  },
  created() {
    this.loadAll();
  },
  methods: {
    async loadAll() {
      try {
        const [aspects, policies, notes] = await Promise.all([
          DeletedItemsDataService.getDeletedAspectRelationships(),
          DeletedItemsDataService.getDeletedPolicyRelationships(),
          DeletedItemsDataService.getDeletedNotes(),
        ]);
        this.aspectRelationships = aspects.data || [];
        this.policyRelationships = policies.data || [];
        this.notes = notes.data || [];
      } catch (e) {
        console.error("Failed to load deleted items", e);
      }
    },
    async restoreAspectRelationship(id) {
      try {
        await DeletedItemsDataService.restoreAspectRelationship(id);
        this.aspectRelationships = this.aspectRelationships.filter(r => r.id !== id);
      } catch (e) {
        alert("Failed to restore: " + (e.message || "Unknown error"));
      }
    },
    async restorePolicyRelationship(id) {
      try {
        await DeletedItemsDataService.restorePolicyRelationship(id);
        this.policyRelationships = this.policyRelationships.filter(r => r.id !== id);
      } catch (e) {
        alert("Failed to restore: " + (e.message || "Unknown error"));
      }
    },
    async restoreNote(id) {
      try {
        await DeletedItemsDataService.restoreNote(id);
        this.notes = this.notes.filter(n => n.id !== id);
      } catch (e) {
        alert("Failed to restore: " + (e.message || "Unknown error"));
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleDateString("en-US", {
        year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"
      });
    },
    truncate(str, len) {
      if (!str) return "";
      return str.length > len ? str.substring(0, len) + "..." : str;
    },
  },
};
</script>
